import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button } from '@mui/material';

const InactivityDialog = ({ open, onClose }) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle
                sx={{
                    backgroundColor: '#f5f5f5',
                    color: '#333333',
                    textAlign: 'center',
                    fontWeight: 'bold',
                }}
            >
                Inactivity Detected
            </DialogTitle>
            <DialogContent
                sx={{
                    backgroundColor: '#ffffff',
                    p: 4,
                    textAlign: 'center',
                }}
            >
                <Typography
                    variant="body1"
                    sx={{
                        mb: 2,
                        fontSize: '1.1rem',
                        color: '#333333',
                    }}
                >
                    You have been inactive for 2 minutes. Please refresh the page to continue the survey.
                </Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', p: 3 }}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={onClose}
                    sx={{
                        color: '#fff',
                        fontWeight: 'bold',
                    }}
                >
                    Refresh
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default InactivityDialog;
